module.exports = __webpack_public_path__ + "static/media/bg-img-1.7fd6f5a7.svg";